import React, { useEffect } from 'react';
import messages from '../messages';
import { LinkButton } from '@atlaskit/button/new';
import { type StateProps } from '../types';
import { DOCS_CONFLUENCE_GUIDE } from '../constants';
import { type WrappedComponentProps } from 'react-intl-next';
import BaseEmptyState from '../base-empty-state';
import { getTutorialContent } from '../../project-pages-improvement/tutorial-content/index';
import { fireScreenAnalytics, fireUIAnalytics } from '@atlassian/analytics-bridge';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

const AutoProvisionedConfluenceEmptyState = ({
	intl,
	spaceKey,
	contentId,
	isProjectPagesSporkRebrandingEnabled,
}: WrappedComponentProps & StateProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireScreenAnalytics(
			createAnalyticsEvent({
				action: 'viewed',
				actionSubjectId: 'autoProvisionedConfluenceEmptyState',
			}),
		);
	}, [createAnalyticsEvent]);

	return (
		<BaseEmptyState
			intl={intl}
			spaceKey={spaceKey}
			contentId={contentId}
			description={messages.confluenceAutoProvisionedDescription}
			primaryActionMessage={messages.createPageButton}
			pageContent={{
				title: intl.formatMessage(messages.tutorialPageName),
				body: getTutorialContent(intl, isProjectPagesSporkRebrandingEnabled),
			}}
			secondaryAction={
				<LinkButton
					appearance="subtle"
					target="_blank"
					href={DOCS_CONFLUENCE_GUIDE}
					testId="confluence-project-pages.empty-state.learn-more-button"
					onClick={() => {
						fireUIAnalytics(
							createAnalyticsEvent({
								action: 'clicked',
								actionSubject: 'link',
								source: 'confluencePageTreeEmptyStateLearnMoreButton',
								actionSubjectId: 'howToUseConfluenceDocumentationLink',
							}),
						);
					}}
				>
					{intl.formatMessage(messages.learnMoreButton)}
				</LinkButton>
			}
		/>
	);
};

export default AutoProvisionedConfluenceEmptyState;
